<script setup lang="ts">
import { nextTick, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getAsset } from "@/helpers/assetsUtils";

const partners = [
  {
    id: "yachtpool",
    image: getAsset('partners',"yachtpool_2026.png"),
    type: 'image',
    title: "partners.yachtpoolTitle",
    content: "partners.yachtpoolContent",
  },
  {
    id: "sealogy",
    image: getAsset('partners',"sealogy.jpg"),
    type: 'image',
    title: "partners.sealogyTitle",
    content: "partners.sealogyContent",
  },
  {
    id: "alianz",
    image: getAsset('partners',"alianz.png"),
    type: 'image',
    title: "partners.alianzTitle",
    content: "partners.alianzContent",
  },
  {
    id: "pantaenius",
    image: getAsset('partners',"pantaenius.png"),
    type: 'image',
    title: "partners.pantaeniusTitle",
    content: "partners.pantaeniusContent",
  },
  {
    id: "IYBA",
    image: getAsset('partners',"IYBA.png"),
    type: 'image',
    title: "partners.IYBATitle",
    content: "partners.IYBAContent",
  },
  {
    id: "EYA",
    image: getAsset('partners',"2025-05-05 EYA UPDATED LOGO.png"),
    type: 'image',
    title: "partners.EYATitle",
    content: "partners.EYAContent",
  },
  {
    id: "yachtfolio",
    image: getAsset('partners',"yachtfolio.png"),
    type: 'image',
    title: "partners.YachtfolioTitle",
    content: "partners.YachtfolioContent",
  },
];

const route = useRoute();

const scrollToElement = async () => {
  await nextTick(); // Ensure DOM is fully rendered
  const elementId = route.params.id;

  if (elementId) {
    setTimeout(() => {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 200);
  }
};

onMounted(() => {
  scrollToElement();
});
</script>

<template>
  <div class="flex flex-col pt-16 space-y-12 bg-gray-50">
    <!-- Title Section -->
    <div class="container text-center mx-auto px-4">
      <h1 class="responsive-title-2 mb-12 font-bold">{{ $t('partners.title') }}</h1>
      <h2 class="responsive-body-large text-gray-500 mt-4" v-html="$t('partners.subtitle')"></h2>
    </div>

    <!-- Partner Sections -->
    <div
        v-for="(partner, index) in partners"
        :key="partner.id"
        :id="partner.id"
        class="max-w-6xl mx-auto flex flex-col md:flex-row gap-10 p-8 rounded-xl bg-white shadow-md"
        :class="{
        'md:flex-row-reverse': index % 2 !== 0,
      }"
    >
      <!-- Image Section -->
      <div class="md:w-1/2 flex justify-center items-center">
        <div v-if="partner.type === 'image'">
          <img
              :src="partner.image"
              :alt="partner.id"
              class="rounded-lg w-full max-w-sm object-scale-down"
          />
        </div>
      </div>

      <!-- Text Section -->
      <div class="md:w-1/2 text-left">
        <h2
            v-html="$t(partner.title)"
            class="responsive-title-3 font-bold text-gray-800"
        ></h2>
        <p
            v-html="$t(partner.content)"
            class="responsive-body-medium mt-4 text-gray-600 leading-relaxed"
        ></p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.news-content {
  scroll-margin-top: 100px;
}

@media (max-width: 1024px) {
  .news-content {
    width: 100%;
  }
}
</style>
